/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Paper from 'apollo-react/components/Paper';
import Tooltip from 'apollo-react/components/Tooltip';
import ChevronRight from 'apollo-react-icons/ChevronRight';
import Info from 'apollo-react-icons/Info';
import Plus from 'apollo-react-icons/Plus';
import React, { useState } from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  root: {
    padding: '0 4px',
    marginBottom: 12,
    userSelect: 'none',
  },
  paper: {
    padding: 10,
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'space-between',
    paddingBottom: 10,
    '& *': {
      marginTop: 0,
      marginBottom: 0,
    },
    '&:hover': {
      color: '#0557d5',
    },
  },
  headerTextContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  headerText: {
    paddingLeft: 4,
    fontWeight: 600,
  },
  buttonsContainer: {
    display: 'flex',
  },
  addButton: {
    marginLeft: 10,
  },
});

const ExpandablePanel = ({ children, label, addRow = () => {}, infoTooltipText = '' }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [isOpen, setIsOpen] = useState(true);

  const handleClick = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  const handleAddRow = (e) => {
    e.stopPropagation();
    addRow();
  };

  return (
    <div className={classes.root}>
      <Paper elevation={1} className={classes.paper}>
        <div onClick={handleClick} className={classes.headerContainer}>
          <div className={classes.headerTextContainer}>
            <ChevronRight
              fontSize="small"
              style={{ transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)' }}
            />
            <p className={classes.headerText}>{label}</p>
          </div>
          <div className={classes.buttonsContainer}>
            {infoTooltipText && (
              <Tooltip title={infoTooltipText} placement="left">
                <Info />
              </Tooltip>
            )}
            {isOpen && (
              <Button
                color="primary"
                variant="secondary"
                onClick={handleAddRow}
                icon={Plus}
                iconPosition="start"
                size="small"
                className={classes.addButton}
              >
                {translateString('Add')}
              </Button>
            )}
          </div>
        </div>
        {isOpen && children}
      </Paper>
    </div>
  );
};

export default ExpandablePanel;
